import { FormTemplateStateEnum, FormTypeEnum } from '@omnea-app/packages/universal/hasura/graphql'
import { FormTemplateInsertData } from '../handleExtOpsIntegrationEnabled'
import type { FormPage } from '@omnea-app/packages/universal/formBuilder/form'

// Question names are kept in sync with the Tropic price-benchmark operation's output variableIds
// (see omnea-extops libs/integrations/tropic .../priceBenchmarkVariables.ts) so the completion handler
// can prefill them by key. The full benchmark JSON (`tropicBenchmark`) rides through executionOutput
// separately and is read by the result view — it is not a form question.
export const TropicQuestionIds = {
  savingsOpportunity: 'savingsOpportunity',
  benchmarkSummary: 'benchmarkSummary',
}

// TODO (INT-508): Migrate this to use form template questions to lock down the question IDs
// TODO (WINT-645): Update config to match the new form template question schema and remove type assertion
export const formTemplate = {
  title: 'Tropic Price Benchmark',
  state: FormTemplateStateEnum.PUBLISHED,
  type: FormTypeEnum.EXTERNAL_OPERATION,
  integration: 'tropic',
  description: 'This form is used to capture the output of the Tropic price benchmark integration',
  config: {
    logic: {},
    pages: [
      {
        id: '1b8ff467-ddc9-4773-a0f8-4333aed65480',
        name: 'benchmark-overview',
        title: 'Price Benchmark',
        questions: [
          {
            id: 'efe67dfc-2371-4576-9192-bcc1d32ed069',
            name: TropicQuestionIds.savingsOpportunity,
            type: 'text',
            title: 'Savings opportunity',
            description: 'Tropic’s overall savings-opportunity rating for this quote',
            visibleIf: [],
            isRequired: false,
          },
          {
            id: '9b18a533-03e0-45cc-90c8-cd3745c1089d',
            name: TropicQuestionIds.benchmarkSummary,
            type: 'text',
            title: 'Benchmark summary',
            description: 'Analyst commentary or summary of the benchmark result',
            visibleIf: [],
            isRequired: false,
          },
        ],
      },
    ],
    enableAiSummary: true,
  },
} as unknown as FormTemplateInsertData

export const TropicQuestionTemplatesArray = formTemplate.config.pages.flatMap((page: FormPage) => page.questions)
export const TropicQuestionIdsArray = Object.values(TropicQuestionIds)
